/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';

import { ArrowRoundedIcon } from '../../../../components/svg-icons/ArrowRoundedIcon';
import { Namespaces } from '../../../../i18n';
import { FetchParams, TablePaginationProps } from '../../../AdminJiraTicketsPage/types';

export const TablePagination = memo<TablePaginationProps>(({ fetchParams, setFetchParams, isLoading }) => {
  const { t } = useTranslation(Namespaces.General);

  const getLabelKey = (key: string) => `jira_support.labels.${key}`;

  const requestStatusMenu = useMemo(
    () =>
      ['all', 'open', 'closed'].map((value, key) => (
        <MenuItem value={value} key={key} style={{ textTransform: 'capitalize' }}>
          {value}
        </MenuItem>
      )),
    [],
  );

  const handleChange = (key: keyof FetchParams) => (e: SelectChangeEvent) =>
    setFetchParams(prev => ({
      ...prev,
      [key]: e.target.value,
    }));

  return (
    <Box display="flex" flexDirection="row" gap={20} alignItems="center" justifyContent="end" width="100%" margin="8px">
      <Box display="flex" flexDirection="row" gap={4}>
        <Typography>{t(getLabelKey('requestStatus'))}</Typography>

        <Select
          value={fetchParams.requestStatus}
          IconComponent={ArrowRoundedIcon}
          variant="outlined"
          fullWidth
          onChange={handleChange('requestStatus')}
          disabled={isLoading}
          style={{ textTransform: 'capitalize' }}
        >
          {requestStatusMenu}
        </Select>
      </Box>
    </Box>
  );
});
